export default "__VITE_ASSET__D_tHEW_O__"